import React__default from 'react';
import PropTypes from 'prop-types';
import { verticalSpacingSizes } from '../../tools/constants.js';

var propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['grid', 'horizontal-collapsed', 'horizontal-spaced', 'vertical-collapsed', 'vertical-spaced']).isRequired,
  marginBottom: PropTypes.oneOf(verticalSpacingSizes),
  marginTop: PropTypes.oneOf(verticalSpacingSizes)
};
function ButtonGroup(_ref) {
  var children = _ref.children,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '' : _ref$marginBottom,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? '' : _ref$marginTop,
    variant = _ref.variant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "button-group",
    "data-margin-bottom": marginBottom || null,
    "data-margin-top": marginTop || null,
    "data-testid": "button-group",
    "data-variant": variant
  }, children);
}
ButtonGroup.propTypes = propTypes;

export { ButtonGroup as default };
//# sourceMappingURL=ButtonGroup.js.map
